var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconMinus = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "icon icon--minus",
  ref: svgRef
}, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 5,
  y1: 12,
  x2: 19,
  y2: 12
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconMinus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconMinus.0f20c741.svg";
export { ForwardRef as ReactComponent };